import { supabase } from '../../lib/supabaseClient';
import { keySession } from './keySession';
import type { ExtractedAgreement } from '../../lib/assistant/mapExtraction';

const FN_PATH = '/functions/v1/cime-tools';
const FN_URL = `${import.meta.env.VITE_SUPABASE_URL}${FN_PATH}`;

async function signedPost(body: unknown) {
  // Session vérifiée AVANT de signer : pas de signature gaspillée si non connecté,
  // et message d'erreur clair plutôt qu'un TypeError sur le destructuring.
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Session expirée — reconnectez-vous.');
  const raw = JSON.stringify(body);
  const { header } = await keySession.sign({ method: 'POST', path: FN_PATH, body: raw });
  const res = await fetch(FN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
      'apikey': import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      'x-cime-signature': header,
    },
    body: raw,
  });
  const out = await res.json();
  if (!res.ok || !out.ok) throw new Error(out.error ?? `HTTP ${res.status}`);
  return out;
}

export async function callExtract(
  dossierId: string,
  doc: { filename: string; mime: string; dataBase64: string },
): Promise<{ extracted: ExtractedAgreement; warnings: string[] }> {
  const out = await signedPost({
    action: 'extract',
    dossier_id: dossierId,
    document: { filename: doc.filename, mime: doc.mime, data_base64: doc.dataBase64 },
  });
  return { extracted: out.extracted as ExtractedAgreement, warnings: (out.warnings ?? []) as string[] };
}

export async function callCommit(
  dossierId: string,
  agreement: ExtractedAgreement,
): Promise<{ id: string }> {
  const out = await signedPost({ action: 'commit', dossier_id: dossierId, agreement });
  return { id: out.agreement.id as string };
}
